import { MigrationPage } from "../MigrationPage";

const StreamingWizard = () => (
  <MigrationPage title="Streaming Wizard" pageType="Streaming Wizard" />
);

export default StreamingWizard;
